import { useState, useEffect, useCallback } from 'react';

import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';

import {
  TAPIResponseFetchApplicationPublic,
  ApplicationResponsDataTypePublic,
  TApplicationFormattedPublic,
} from './fetch-application-public.types';

export const useAPIFetchApplicationPublic = (
  id: string
): TAPIResponseFetchApplicationPublic => {
  const { get, error, loading, response } = useFetch(API_ROUTES.APPLICATIONS_PUBLIC, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const [responseData, setResponseData] = useState(
    {} as unknown as TApplicationFormattedPublic
  );

  const fetchApplication = useCallback(
    async (id: string): Promise<void> => {
      const { data } = await get(`/${id}`);
      if (data) {
        setResponseData(
          data?.id
            ? ({
                ...(data as ApplicationResponsDataTypePublic),
                clientId: 'ghfjrdwdfgefsacgrtghseerfsqwer',
                secret: 'ghfjrdwdfgefsacgrtghseerfsqwer',
              } as TApplicationFormattedPublic)
            : data
        );
      }
    },
    [get]
  );

  useEffect(() => {
    fetchApplication(id);
    // eslint-disable-next-line
  }, []);

  return {
    data: responseData,
    loading,
    error,
    loaded: response.ok,
    fetchApplication,
  };
};
